import { render } from "./RadioButtonForm.vue?vue&type=template&id=a50612e8&ts=true"
import script from "./RadioButtonForm.vue?vue&type=script&lang=ts"
export * from "./RadioButtonForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/RadioButtonForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a50612e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a50612e8', __exports__)) {
    api.reload('a50612e8', __exports__)
  }
  
  module.hot.accept("./RadioButtonForm.vue?vue&type=template&id=a50612e8&ts=true", () => {
    api.rerender('a50612e8', render)
  })

}


export default __exports__